export enum ActionTypes {
  sendEmail = 'sendEmail',
  stopRecipe = 'stopRecipe',
  startRecipe = 'startRecipe',
  deleteRecipe = 'deleteRecipe',
  stopFlow = 'stopFlow',
  stopAllFlows = 'stopAllFlows',
  startFlow = 'startFlow',
  deleteConnection = 'deleteConnection',
  deleteCanvasApp = 'deleteCanvasApp',
  deleteFlow = 'deleteFlow',
  deleteEnvironment = 'deleteEnvironment',
  quarantineApplication = 'quarantineApplication',
  unquarantineApplication = 'unquarantineApplication',
  sendWebhook = 'sendWebhook',
  stopAllRecipes = 'stopAllRecipes',
  addOwnerToCanvasApp = 'addOwnerToCanvasApp',
  addOwnerToCustomConnector = 'addOwnerToCustomConnector',
  addOwnerToFlow = 'addOwnerToFlow',
  addOwnerToEnvironment = 'addOwnerToEnvironment',
  addOwnerToConnection = 'addOwnerToConnection',
  addOwnerToCopilot = 'addOwnerToCopilot',
  exemptViolation = 'exemptViolation',
  resetViolationStatus = 'resetViolationStatus',
  wait = 'wait',
  secureFlowSteps = 'secureFlowSteps',
  setCopilotAuthentication = 'setCopilotAuthentication',
  removeAccessFromCopilot = 'removeAccessFromCopilot',
  addLabel = 'addLabel',
  removeAccess = 'removeAccess',
  isolateFlowResource = 'isolateFlowResource',
  isolateCopilotResource = 'isolateCopilotResource',
  enableAgentAction = 'enableAgentAction',
  disableAgentAction = 'disableAgentAction',
  setActionStatus = 'setActionStatus', // exists only on FE to combine enable and disable actions into one action to properly display in Playbooks
  setAgentActionAuthenticationMode = 'setAgentActionAuthenticationMode',
  setUserContext = 'setUserContext', // exists only on FE to specify Authentication mode actions to properly display in Playbooks
  setAuthorContext = 'setAuthorContext', // exists only on FE to specify Authentication mode actions to properly display in Playbooks
  setAgentActionConfirmationMode = 'setAgentActionConfirmationMode',
  setStrictMode = 'setStrictMode', // exists only on FE to specify Confirmation mode actions to properly display in Playbooks
  setDisabledMode = 'setDisabledMode', // exists only on FE to specify Confirmation mode actions to properly display in Playbooks
}

export const AddOwnerActions = [
  ActionTypes.addOwnerToCanvasApp,
  ActionTypes.addOwnerToConnection,
  ActionTypes.addOwnerToCustomConnector,
  ActionTypes.addOwnerToEnvironment,
  ActionTypes.addOwnerToFlow,
  ActionTypes.addOwnerToCopilot,
];

export const RemovePermissionsActions = [ActionTypes.removeAccessFromCopilot];

export const RemoveAccessActions = [ActionTypes.removeAccess];

export const IsolateResourceActions = [ActionTypes.isolateCopilotResource, ActionTypes.isolateFlowResource];
